<ion-footer color="customSideMenuBackground">
  <ion-toolbar
    [color]="
      appChannel && appChannel === 'mastercapacitorv7'
        ? 'notValid'
        : 'customSideMenuBackground'
    "
  >
    <img
      *ngIf="
        !isNativePlatform &&
        !(
          groupApp &&
          groupApp.design_settings &&
          groupApp.design_settings.disable_app_darkmode
        )
      "
      (click)="goToPaymentTermsPage()"
      src="assets/icons/img_W21_aa.png"
      alt="Level AA conformance, W3C WAI Web Content Accessibility Guidelines 2.1"
      style="
        position: absolute;
        top: 0;
        left: 2px;
        cursor: pointer;
        z-index: 10000;
      "
      [style.height.px]="
        windowDimensions && windowDimensions.width < 400 ? 20 : 30
      "
    />

    <div
      *ngIf="showTeamSoftLogo"
      style="
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        z-index: 10000;
      "
      [style.height.px]="
        windowDimensions && windowDimensions.width < 400 ? 28 : 40
      "
    >
      <img
        src="assets/flatIcons/teamsoftLogo-transparent-new.png"
        alt="teamsoft"
        [style.height.px]="
          windowDimensions && windowDimensions.width < 400 ? 18 : 25
        "
      />
    </div>

    <ion-item
      *ngIf="
        !isNativePlatform &&
        groupApp &&
        groupApp.design_settings &&
        groupApp.design_settings.disable_app_darkmode
      "
      class="w3cBadgeItem ion-no-padding ion-no-margin"
      lines="none"
      detail="false"
      button
      (click)="goToPaymentTermsPage()"
    >
      <img
        src="assets/icons/img_W21_aa.png"
        alt="Level AA conformance, W3C WAI Web Content Accessibility Guidelines 2.1"
        [style.height.px]="
          windowDimensions && windowDimensions.width < 400 ? 20 : 30
        "
      />
    </ion-item>

    <ion-item
      *ngIf="
        !(
          groupApp &&
          groupApp.design_settings &&
          groupApp.design_settings.disable_app_darkmode
        )
      "
      [color]="
        appChannel && appChannel === 'mastercapacitorv7'
          ? 'notValid'
          : 'customSideMenuBackground'
      "
      class="ion-no-padding ion-no-margin"
      lines="none"
    >
      <ion-button
        color="changeDarkModeButton"
        fill="clear"
        slot="end"
        (click)="darkMode()"
      >
        <ion-icon
          slot="icon-only"
          *ngIf="!darkTheme"
          src="assets/ionicons/moon-outline.svg"
        >
        </ion-icon>
        <ion-icon
          slot="icon-only"
          *ngIf="darkTheme"
          src="assets/ionicons/sunny-outline.svg"
        >
        </ion-icon>
      </ion-button>
    </ion-item>
    <ion-item
      [color]="
        appChannel && appChannel === 'mastercapacitorv7'
          ? 'notValid'
          : 'customSideMenuBackground'
      "
      lines="none"
      *ngIf="
        stores &&
        stores.length === 1 &&
        currentStore &&
        currentStore.paymentGateways &&
        currentStore.paymentGateways.nexi &&
        currentStore.paymentGateways.nexi.active
      "
    >
      <ion-label style="font-size: small; line-height: 1.1">
        <ion-text color="medium">
          <!-- {{
            currentStore.store_name_mobileorder &&
            currentStore.store_name_mobileorder[selectedLanguage]
              ? currentStore.store_name_mobileorder[selectedLanguage]
              : currentStore.store_name_langs &&
                currentStore.store_name_langs[selectedLanguage]
              ? currentStore.store_name_langs[selectedLanguage]
              : currentStore.store_name_langs &&
                currentStore.store_name_langs.el
              ? currentStore.store_name_langs.el
              : currentStore.store_name
          }} -->

          {{ "catalog.cart-catalog.vatNumber" | translate }}:
          {{ currentStore.vatNumber }} <br />

          {{ currentStore.address }}
          <br />

          {{ currentStore.vatEmailStore ? currentStore.vatEmailStore : "" }}

          {{ currentStore.telephone ? currentStore.telephone : "" }}
          <br />

          <br />
        </ion-text>
      </ion-label>
    </ion-item>

    <ion-item
      [color]="
        appChannel && appChannel === 'mastercapacitorv7'
          ? 'notValid'
          : 'customSideMenuBackground'
      "
      class="creditsItemPaddings"
      lines="none"
      detail="false"
      [button]="
        groupApp &&
        groupApp.design_settings &&
        groupApp.design_settings.menuFooterTabs &&
        windowDimensions &&
        windowDimensions.width < 500
          ? false
          : true
      "
      (click)="
        groupApp &&
        groupApp.design_settings &&
        groupApp.design_settings.menuFooterTabs &&
        windowDimensions &&
        windowDimensions.width < 500
          ? ''
          : openLink('https://www.deliverymanager.gr')
      "
    >
      <!-- <ion-icon style="font-size: 80px;" slot="start" src="assets/deliveryManagerLogo/deliveryManager.svg">

      </ion-icon>
      <ion-thumbnail slot="start">
     
      </ion-thumbnail> -->
      <ion-avatar slot="start">
        <img
          *ngIf="!animationPlaying"
          [src]="
            darkTheme || showWhiteLogoDeliveryManager
              ? 'assets/deliveryManagerLogo/deliveryManagerWhite.png'
              : 'assets/deliveryManagerLogo/deliveryManager.svg'
          "
          alt="delivery-manager"
        />
        <ng-lottie
          *ngIf="startAnimation"
          (animationCreated)="animationCreated($event)"
          (domLoaded)="animStartPlaying()"
          (loopComplete)="animationLoopCompleted($event)"
          (error)="animationError($event)"
          style="z-index: 100"
          [options]="animationDeliveryManagerOptions"
        >
        </ng-lottie>
      </ion-avatar>
      <ion-label>
        <ion-text style="font-size: small" color="poweredByTextColor"
          >Powered by deliverymanager.gr</ion-text
        >
        <p>
          <ion-text color="poweredByTextColor">
            v{{ version }} © DM SOFT IKE</ion-text
          >
        </p>
      </ion-label>
    </ion-item>
  </ion-toolbar>
</ion-footer>
